"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.yieldToMain = yieldToMain;
function yieldToMain() {
  return new Promise(function (resolve) {
    setTimeout(resolve, 0);
  });
}
var _default = yieldToMain;
exports.default = _default;